import {ACTION_TYPE} from '../../core/redux/actionType';
import {IAppState} from '../../core/redux/IAppState';
import {assoc} from '../../language/module';


type SelectedResortAction = {
  type: ACTION_TYPE.SELECTED_RESORT;
  resortId: number;
}

export const selectedResortAction = (resortId: number): SelectedResortAction  => ({
  type: ACTION_TYPE.SELECTED_RESORT,
  resortId: resortId,
})

export const selectedResortReducer = (state: IAppState, action: SelectedResortAction): IAppState => {
  if (action.type !== ACTION_TYPE.SELECTED_RESORT || state.resortDetails?.allResorts === undefined) {
    return state;
  }

  const resort = state.resortDetails?.allResorts.getValues().find(res => res.resortId === action.resortId);

  if (!resort) return state;

  return assoc(
    'selectedResort',
    resort,
    state,
  )
}